import React, { useEffect, useRef, useState } from 'react'
import './DividendFiltering.scss'
import { Col, Container, Image, Row, InputGroup, Form } from 'react-bootstrap'
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar'
import { DividendApi } from "../../../services/dividend/api";
import { Configuration } from "../../../services/dividend/configuration";
import { useDispatch, useSelector } from "react-redux";
import { Toast } from 'primereact/toast';
import lodash, { findIndex } from 'lodash';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import { IndexServiceApi, PageName } from "../../../services/actionHub/api";
import { Configuration as ActionHubConfiguration } from "../../../services/actionHub/configuration"
import DataTableComponent from '../../../components/dataTables/dataTable';
import Spinner from '../../../components/spinner';
import DividendGraphs from '../../../components/charts/dividendCharts/dividendGraphs';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
import { is } from 'date-fns/locale';
import NumberFormatter from '../../../formatters/NumberFormatter';
export default function DividendFiltering() {
    const { t } = useTranslation();
    const api = new DividendApi(new Configuration({ basePath: process.env.REACT_APP_DIVIDEND_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_DIVIDEND_API_BASE_PATH));
    const actionHubIndexApi = new IndexServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const toast = useRef(null);
    const token = useSelector((state) => state.auth?.token);
    const [sourceSelectItem, setSourceSelectItem] = useState([]);
    const [visible, setVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [symbol, setSymbol] = useState();
    const [indexList, setIndexList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [selectedIndexCode, setSelectedIndexCode] = useState();
    const [tableData, setTableData] = useState([]);
    const numberFormatter = new NumberFormatter();

    const columnsAll = [
        // { id: 0, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left', width: '1%' },
        // { id: 1, field: 'code', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '10%', clikable: true },
        { id: 1, field: 'searchableHeader', displayName: 'Sembol', header: t('tableHeader.symbol'), filterField: "code", isFrozen: true, format: "code-s-f-m", isVisible: true, align: 'left', width: '5%', paddingRight: '10px', sortable: false },
        // { id: 2, field: 'dividendExpectChart', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '6%', clikable: true, isFrozen: true },
        { id: 3, field: 'lastYearDividendYield', displayName: t('tableHeader.lastYearDividendYield') + '(%)', header: t('tableHeader.lastYearDividendYieldFiltering') + ' (%)', isVisible: true, align: 'right', width: '16% ', clikable: false, sortable: true },
        { id: 4, field: 'threeYearAverageDividendYield', displayName: t('tableHeader.lastThreeYearsDividendYield'), header: t('tableHeader.lastThreeYearsDividendYieldFiltering'), isVisible: true, align: 'right', width: '12% ', clikable: false, sortable: true },
        { id: 5, field: 'fiveYearAverageDividendYield', displayName: t('tableHeader.lastFiveYearsDividendYield'), header: t('tableHeader.lastFiveYearsDividendYieldFiltering'), isVisible: true, align: 'right', width: '12% ', clikable: false, sortable: true },
        { id: 10, field: 'threeYearDividendCAGR', displayName: t('tableHeader.threeYearDividendCAGR') + ' (%)', header: t('tableHeader.threeYearDividendCAGR') + ' (%)', isVisible: true, align: 'right', width: '11% ', clikable: false, sortable: true },
        { id: 11, field: 'threeYearRatioCAGR', displayName: t('tableHeader.threeYearRatioCAGR') + ' (%)', header: t('tableHeader.threeYearRatioCAGR') + ' (%)', isVisible: true, align: 'right', width: '11% ', clikable: false, sortable: true },
        { id: 12, field: 'threeYearAvaregeProfitDistributeRatio', displayName: t('tableHeader.threeYearAvaregeProfitDistributeRatio') + ' (%)', header: t('tableHeader.threeYearAvaregeProfitDistributeRatio') + ' (%)', isVisible: true, align: 'right', width: '20% ', clikable: false, sortable: true },
        { id: 8, field: 'ybgYield', displayName: t('tableHeader.ybgYield') + ' (%)', header: t('tableHeader.ybgYield') + ' (%)', isVisible: true, align: 'right', width: '7% ', clikable: false, sortable: true },
        { id: 9, field: 'yearlyYield', displayName: t('tableHeader.yearlyYield') + ' (%)', header: t('tableHeader.yearlyYield') + ' (%)', isVisible: true, align: 'right', width: '11% ', clikable: false, sortable: true },
        { id: 7, field: 'fk', displayName: t('tableHeader.p-e'), header: t('tableHeader.p-e'), isVisible: true, align: 'right', width: '7% ', clikable: false, sortable: true },
        { id: 6, field: 'pddd', displayName: t('tableHeader.pddd'), header: t('tableHeader.pddd'), isVisible: true, align: 'right', width: '8% ', clikable: false, sortable: true },
    ]

    useEffect(() => {
        getActionHubContentData();
    }, []);

    useEffect(() => {
        if (selectedIndexCode !== undefined && selectedIndexCode !== null && selectedIndexCode !== "") {
            getData();
        }
    }, [selectedIndexCode]);

    const handleClose = () => setVisible(false)

    //#region DataTable Dividend Graph Modal
    const openDividendGrapshModal = (item) => {

        try {
            if (item === undefined || item === null) {
                return;
            }
            setVisible(true);
            setSymbol(item);
        } catch (error) {
            console.log('openDividendGrapshModal error: ', error);
        }
    }

    //#endregion DataTable Dividend Graph Modal

    //#region Dropdown Picker

    const onIndexListChange = (e) => {
        console.log('onIndexChange', e);
        let index = findIndex(indexList, { entityId: e.entityId });
        if (index !== -1) {
            setSelectedIndex(indexList[index]);
            setSelectedIndexCode(indexList[index].code);
        }
        else {
            setSelectedIndex(indexList[0]);
            setSelectedIndexCode(indexList[0].code);
        }
    }

    //#endregion Dropdown Picker


    //#region API CALLS 

    const getActionHubContentData = () => {

        actionHubIndexApi.actionhubCustomindexesGet(token, PageName.DividendFiltering).then((res) => {
            if (res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                toast.current.show({ severity: 'error', summary: 'Hata Content', detail: res.data.error, life: 3000 });
                console.log('contentGet:  response error');
            }
            else {
                const indexListData = lodash.map(res.data.indexes, (res) => ({
                    name: res['name'].trTr,
                    nameEnUs: res['name'].enUs,
                    code: res.code,
                    entityId: res.entityId,
                }))
                setIndexList(indexListData);
                setSelectedIndex(indexListData[0]);
                setSelectedIndexCode(indexListData[0].code);
            }
        }).catch((err) => {
            // console.log("actionHubIndexApi: " + err);
        });
    }

    const toNumberOrNull = (val) => {
        const num = parseFloat(val);
        return Number.isFinite(num) ? num : null;   // NaN, Infinity vb. -> null
    };

    const getData = () => {
        try {
            setIsLoading(true);
            
            api.apiDividendDividendfilteringGet(token, selectedIndexCode).then((res) => {
                

                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                }
                else {
                    console.log('apiDividendDividendfilteringGet : ', res.data);

                    let data = res.data.map((item) => {
                        return {
                            code: item.equity,
                            lastYearDividendYield: toNumberOrNull(item.lastYearDividendYield),
                            threeYearAverageDividendYield: toNumberOrNull(item.threeYearAverageDividendYield),
                            fiveYearAverageDividendYield: toNumberOrNull(item.fiveYearAverageDividendYield),
                            pddd: toNumberOrNull(item.pddd),
                            fk: toNumberOrNull(item.fk),
                            ybgYield: toNumberOrNull(item.ybgYield),
                            yearlyYield: toNumberOrNull(item.yearlyYield),
                            threeYearDividendCAGR: toNumberOrNull(item.threeYearDividendCAGR),
                            threeYearRatioCAGR: toNumberOrNull(item.threeYearRatioCAGR),
                            threeYearAvaregeProfitDistributeRatio: toNumberOrNull(item.threeYearAvaregeProfitDistributeRatio),
                            entityId: item.entityId
                        }
                    });
                    setTableData(data);
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 100);
                }
            }).catch((err) => {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('aserviceRelatedErrorOccurred'), life: 3000 });
                setIsLoading(false);
                setTableData([]);
            });
        } catch (error) {
            console.log('apiDividendDividendfilteringGet error: ', error);
        }
    }

    //#endregion API CALLS

    return (
        <div className='' id='DividendFiltering'>
            <Toast ref={toast} position="bottom-right" />

            <Container>
                <Row>
                    <LiveTickerBar />
                </Row>
                <Row className='m-t-15'>
                    <h1 className='roboto-bold-24 color-text'>{t('dividend.dividendFiltering.title')}</h1>
                </Row>
            </Container>

            <Container className='m-t-10'>
                <Row>
                    <Col md='3' className=''>
                        <DropdownPicker listData={indexList} selectedListItem={selectedIndex} onListItemChange={onIndexListChange} icon={true} />
                    </Col>
                </Row>
            </Container>

            <Container className='m-t-10'>
                <Row>
                    <Col md='12'>
                        {isLoading && <Spinner height="600px" />}
                        {!isLoading &&
                            <div className='dividend-expect-table'>
                                <DataTableComponent columnsProp={columnsAll} dataProp={tableData} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={'100%'} openDividendGrapshModal={openDividendGrapshModal} />
                            </div>
                        }
                    </Col>
                </Row>
            </Container>

            <DividendGraphs modalVisible={visible} closeModal={handleClose} symbol={symbol} />

        </div>
    )
}

